import useSharedStyles from '../shared.styles'

const useStyles = {
  intro: (isMobile: boolean) => ({
    ...useSharedStyles.intro(isMobile),
    gap: 6.25,
    alignItems: 'center',
  }),
  screen: (isMobile: boolean) => ({
    ...useSharedStyles.screen(isMobile),
    paddingY: 5,
  }),
  title: {
    maxWidth: 582,
    textAlign: 'center',
    fontWeight: 500,
  },
  support: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
  },
  caption: {
    textAlign: 'center',
  },
}

export default useStyles
